exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".basicInfo___KIOq6 {\n  padding-left: 16px;\n  height: 100%;\n  background-color: #F7F7F7;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow-y: auto;\n}\n.basicInfo___KIOq6 .card {\n  padding: 20px 0;\n  border-bottom: 1px solid #E8E9EB;\n}\n.basicInfo___KIOq6 .card .title {\n  display: block;\n  margin-bottom: 10px;\n}\n.basicInfo___KIOq6 .card .list {\n  display: -ms-flexbox;\n  display: flex;\n  line-height: 24px;\n  padding-right: 10px;\n}\n.basicInfo___KIOq6 .card .list .label {\n  -ms-flex: 0 0 56px;\n      flex: 0 0 56px;\n  margin-right: 20px;\n  color: #68758E;\n}\n.basicInfo___KIOq6 .card .list .info.click {\n  color: #0093FF;\n}\n", ""]);

// exports
exports.locals = {
	"basicInfo": "basicInfo___KIOq6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/personalInfo/basicInfo/index.less
// module id = 1147
// module chunks = 0